<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div class="inner-wrap">

  <ng-container *ngIf="authCheck === false">

  <ul class="join-tab">
    <li class="active"><span>01.</span>약관동의 및 본인인증</li>
    <li><span>02.</span>정보입력</li>
    <li><span>03.</span>가입완료</li>
  </ul>

  <div class="join-step1">
    <div class="join-info">
            한국냉동공조산업협회 이용약관과 개인정보 보호정책을 읽어보시고 동의하셔야만 회원가입이 완료됩니다.<br/>
             가입하시기 전에 아래 준수사항도 반드시 함께 확인하시기 바랍니다.
    </div>
    <div class="terms">

			제 1 조 (목적)<br>
			본 약관은 한국냉동공조산업협회가 제공하는 모든 서비스(이하 "서비스")의 이용조건 및 절차, 이용자와 REF 사이트의 권리, 의무, 책임사항과 기타 필요한 사항을 규정함을 목적으로 합니다.<br>
			<br>
			제 2 조 (약관의 효력과 변경)<br>
			1. 한국냉동공조산업협회은 귀하가 본 약관 내용에 동의하는 경우, 한국냉동공조산업협회의 서비스 제공 행위 및 귀하의 서비스 사용 행위에 본 약관이 우선적으로 적용됩니다.<br>
			2. 한국냉동공조산업협회은 본 약관을 사전 고지 없이 변경할 수 있고, 변경된 약관은 한국냉동공조산업협회 내에 공지하거나 e-mail을 통해 회원에게 공지하며, 공지와 동시에 그 효력이 발생됩니다. 이용자가 변경된 약관에 동의하지 않는 경우, 이용자는 본인의 회원등록을 취소(회원탈퇴)할 수 있으며 계속 사용의 경우는 약관 변경에 대한 동의로 간주됩니다.<br>
			<br>
			제 3 조 (약관 외 준칙)<br>
			1. 본 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법, 정보통신윤리위원회심의규정, 정보통신 윤리강령, 프로그램보호법 및 기타 관련 법령의 규정에 의합니다.<br>
			<br>
			제 4 조 (용어의 정의)<br>
			본 약관에서 사용하는 용어의 정의는 다음과 같습니다.<br>
			1. 이용자 : 본 약관에 따라 한국냉동공조산업협회가 제공하는 서비스를 받는 자.<br>
			2. 가입 : 한국냉동공조산업협회가 제공하는 신청서 양식에 해당 정보를 기입하고, 본 약관에 동의하여 서비스 이용계약을 완료시키는 행위. <br>
			3. 회원 : 한국냉동공조산업협회에 개인 정보를 제공하여 회원 등록을 한 자로서 한국냉동공조산업협회가 제공하는 서비스를 이용할 수 있는 자.<br>
			4. 비밀번호 : 이용자와 회원ID가 일치하는지를 확인하고 통신상의 자신의 비밀보호를 위하여 이용자 자신이 선정한 문자와 숫자의 조합.<br>
			5. 탈퇴 : 회원이 이용계약을 종료시키는 행위. <br>
			<br>
			제 2 장 서비스 제공 및 이용<br>
			<br>
			제 5 조 (이용계약의 성립)<br>

			1. 이용계약은 신청자가 온라인으로 한국냉동공조산업협회에서 제공하는 소정의 가입신청 양식에서 요구하는 사항을 기록하여 가입을 완료하는 것으로 성립됩니다.<br>

			2. 한국냉동공조산업협회은 다음 각 호에 해당하는 이용계약에 대하여는 가입을 취소할 수 있습니다. <br>
			<br>

			1) 다른 사람의 명의를 사용하여 신청하였을 때 <br>
			2) 이용계약 신청서의 내용을 허위로 기재하였거나 신청하였을 때<br>
			3) 다른 사람의 한국냉동공조산업협회 서비스 이용을 방해하거나 그 정보를 도용하는 등의 행위를 하였을 때<br>
			4) 한국냉동공조산업협회를 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우 <br>
			5) 기타 한국냉동공조산업협회가 정한 이용신청요건이 미비 되었을 때<br>
			<br>


			제 6 조 (회원정보 사용에 대한 동의)<br>

			1. 회원의 개인정보는 공공기관의 개인정보보호에 관한 법률에 의해 보호됩니다.<br>
			2. 한국냉동공조산업협회의 회원 정보는 다음과 같이 사용, 관리, 보호됩니다. <br><br>

			1) 개인정보의 사용 : 한국냉동공조산업협회은 서비스 제공과 관련해서 수집된 회원의 신상정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않습니다. 단, 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있는 경우, 범죄에 대한 수사상의 목적이 있거나 정보통신윤리 위원회의 요청이 있는 경우 또는 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우, 귀하가 REF 사이트에 제공한 개인정보를 스스로 공개한 경우에는 그러하지 않습니다.<br>
			2) 개인정보의 관리 : 귀하는 개인정보의 보호 및 관리를 위하여 서비스의 개인정보관리에서 수시로 귀하의 개인정보를 수정/삭제할 수 있습니다.<br>
			3) 개인정보의 보호 : 귀하의 개인정보는 오직 귀하만이 열람/수정/삭제 할 수 있으며, 이는 전적으로 귀하의 ID와 비밀번호에 의해 관리되고 있습니다. 따라서 타인에게 본인의 ID와 비밀번호를 알려주어서는 안되며, 작업 종료시에는 반드시 로그아웃 해주시기 바랍니다.<br>

			3. 회원이 본 약관에 따라 이용신청을 하는 것은, 한국냉동공조산업협회가 신청서에 기재된 회원정보를 수집, 이용하는 것에 동의하는 것으로 간주됩니다. <br>
			<br>
			제 7 조 (사용자의 정보 보안)<br>
			1. 가입 신청자가 한국냉동공조산업협회 서비스 가입 절차를 완료하는 순간부터 귀하는 입력한 정보의 비밀을 유지할 책임이 있으며, 회원의 ID와 비밀번호를 사용하여 발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다. <br>

			2. ID와 비밀번호에 관한 모든 관리의 책임은 회원에게 있으며, 회원의 ID나 비밀번호가 부정하게 사용되었다는 사실을 발견한 경우에는 즉시 한국냉동공조산업협회에 신고하여야 합니다. 신고를 하지 않음으로 인한 모든 책임은 회원 본인에게 있습니다. <br>

			3. 이용자는 한국냉동공조산업협회 서비스의 사용 종료시 마다 정확히 접속을 종료해야 하며, 정확히 종료하지 아니함으로써 제3자가 귀하에 관한 정보를 이용하게 되는 등의 결과로 인해 발생하는 손해 및 손실에 대하여 한국냉동공조산업협회은 책임을 부담하지 아니합니다.<br>
			<br>

			제 8 조 (서비스의 중지)<br>
			1. 한국냉동공조산업협회은 이용자가 본 약관의 내용에 위배되는 행동을 한 경우, 임의로 서비스 사용을 제한 및 중지할 수 있습니다.<br>
			<br>
			제 9 조 (서비스의 변경 및 해지)<br>
			1. 한국냉동공조산업협회은 귀하가 서비스를 이용하여 기대하는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않으며, 회원이 본 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관하여는 책임을 지지 않습니다. <br>
			2. 한국냉동공조산업협회은 서비스 이용과 관련하여 가입자에게 발생한 손해 중 가입자의 고의, 과실에 의한 손해에 대하여 책임을 부담하지 아니합니다.<br>
			<br>


			제 10 조 (게시물의 저작권)<br>
			1. 귀하가 게시한 게시물의 내용에 대한 권리는 귀하에게 있습니다. <br>
			2. 한국냉동공조산업협회은 게시된 내용을 사전 통지 없이 편집, 이동할 수 있는 권리를 보유하며, 게시판 운영원칙에 따라 사전 통지 없이 삭제할 수 있습니다.<br>
			3. 귀하의 게시물이 타인의 저작권을 침해함으로써 발생하는 민, 형사상의 책임은 전적으로 귀하가 부담하여야 합니다.<br>
			<br>
			제 3 장 의무 및 책임<br>
			제 11 조 (한국냉동공조산업협회의 의무)<br>
			<br>

			1. 한국냉동공조산업협회은 회원의 개인 신상 정보를 본인의 승낙없이 타인에게 누설, 배포하지 않습니다.<br>
			다만, 전기통신관련법령 등 관계법령에 의하여 관계 국가기관 등의 요구가 있는 경우에는 그러하지 아니합니다.<br>
			<br>

			제 12 조 (회원의 의무)<br>

			1. 회원 가입 시에 요구되는 정보는 정확하게 기입하여야 합니다. 또한 이미 제공된 귀하에 대한 정보가 정확한 정보가 되도록 유지, 갱신하여야 하며, 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.<br>

			2. 회원은 한국냉동공조산업협회의 사전 승낙 없이 서비스를 이용하여 어떠한 영리행위도 할 수 없습니다.<br>
			<br>


			제 4 장 기타<br>

			제 13 조 (양도금지)<br>

			1. 회원이 서비스의 이용권한, 기타 이용계약 상 지위를 타인에게 양도, 증여할 수 없습니다.<br>
			<br>

			제 14 조 (손해배상)<br>

			1. 한국냉동공조산업협회은 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 한국냉동공조산업협회가 고의로 행한 범죄행위를 제외하고 이에 대하여 책임을 부담하지 아니합니다.<br>
			<br>

			제 15 조 (면책조항)<br>

			1. 한국냉동공조산업협회은 회원이나 제3자에 의해 표출된 의견을 승인하거나 반대하거나 수정하지 않습니다. 한국냉동공조산업협회은 어떠한 경우라도 회원이 서비스에 담긴 정보에 의존해 얻은 이득이나 입은 손해에 대해 책임이 없습니다. <br>

			2. 한국냉동공조산업협회은 회원간 또는 회원과 제3자간에 서비스를 매개로 하여 물품거래 혹은 금전적 거래 등과 관련하여 어떠한 책임도 부담하지 아니하고, 회원이 서비스의 이용과 관련하여 기대하는 이익에 관하여 책임을 부담하지 않습니다.<br>
			<br>

			제 16 조 (재판관할)<br>

			1. 한국냉동공조산업협회와 이용자간에 발생한 서비스 이용에 관한 분쟁에 대하여는 대한민국 법을 적용하며, 본 분쟁으로 인한 소는 대한민국의 법원에 제기합니다.<br>
			부 칙 1. (시행일) 본 약관은 2005년 4월 1일부터 시행됩니다.

    </div>
    <label class="check-txt"><input type="checkbox" [(ngModel)]="agree" [value]="true"> 이용약관을 읽었으며 내용에 동의합니다.</label>

    <div class="section-title">본인인증</div>
    <div class="certification hp-certification">
      <a class="btn1 cp" (click)="setAuth('H')">휴대폰 인증</a>
      <div class="txt">
              입력하시는 본인정보는 본인확인의 용도로만 사용되며,<br/>
              본인확인기관의 인증을 통해 진행됩니다.<br/>
              이에 동의하실 경우, 본인확인을 진행해주세요.
      </div>
    </div>
    <div class="certification ipin-certification">
      <a class="btn1 cp" (click)="setAuth('I')">아이핀(I-PIN) 인증</a>
      <div class="txt">
              공공 아이핀은 인터넷상의 개인식별 번호를 의미하며,<br/>
              대면확인이 어려운 인터넷에서 주민번호를 사용하지 않고도 <br/>
              본인임을 확인할 수 있는 수단 입니다.
      </div>
    </div>

    <div class="cb"></div>
  </div>

</ng-container>

<ng-container *ngIf="authCheck === true">

<ul class="join-tab">
  <li><span>01.</span>약관동의 및 본인인증</li>
  <li class="active"><span>02.</span>정보입력</li>
  <li><span>03.</span>가입완료</li>
</ul>

<div class="join-step2">
  <div class="join-guide">가입 종류 선택 후 정보를 입력해주세요.</div>

  <ul class="kind-tab">
    <li class="nav-item"><a class="cp nav-link" [ngClass]="{active: tabIndex==0}" (click)="setTabIndex(0)">일반회원</a></li>
    <li class="nav-item"><a class="cp nav-link" [ngClass]="{active: tabIndex==1}" (click)="setTabIndex(1)">통계담당</a></li>
    <li class="nav-item"><a class="cp nav-link" [ngClass]="{active: tabIndex==2}" (click)="setTabIndex(2)">기업회원</a></li>
  </ul>

  <div class="tab-content">
    <div class="tab-pane" [ngClass]="{show: tabIndex==0, active: tabIndex==0, fadeIn: tabIndex==0, fade: tabIndex!==0}">
      <!--
      <app-member-kind1 *ngIf="tabIndex==0" [authInfo]="authInfo"></app-member-kind1>
      //-->
      <ng-container *ngIf="tabIndex==0">

      <form [formGroup]="form">

        <input type="hidden" id="userGubun" formControlName="userGubun" />
        <input type="hidden" id="birthType" formControlName="birthType" />
        <input type="hidden" id="memberStatus" formControlName="memberStatus" />
        <input type="hidden" id="gender" formControlName="gender" />
        <input type="hidden" id="dupinfo" formControlName="dupinfo" />

        <div class="join-input">
          <div class="page-title">일반회원 정보입력</div>

          <div class="info">*필수입력입니다.</div>

          <table>
          <colgroup>
            <col class="col1">
            <col class="col2">
          </colgroup>

          <tbody>
          <tr>
            <th><span class="necessary">*</span>아이디</th>
            <td>
              <input type="text" id="userId" formControlName="userId" [ngClass]="[formErrors['userId'] ? 'formErrors' : '', formErrors['idCheck'] ? 'formErrors' : '']" placeholder="{{ formErrors['userId'] ? formErrors['userId'] : '아이디 (띄어쓰기 없이 5~20자의 영문,숫자)' }}" (keydown)="setIdCheckInit()" />
              <button class="btn1" (click)="checkIdDuplicate()">중복체크</button>
              <span *ngIf="!formErrors['idCheck']" class="">(아이디 중복체크를 하셔야만 등록 가능합니다.)</span>
              <span *ngIf="formErrors['idCheck']" class="cred">아이디 중복체크을 하시기 바랍니다.</span>
              <input type="hidden" formControlName="idCheck" pattern="{{checkTrue}}" />
            </td>
          </tr>
          <tr>
            <th><span class="necessary">*</span>비밀번호</th>
            <td>
              <input type="password" id="password" formControlName="password" [ngClass]="{formErrors:formErrors['password']}" placeholder="비밀번호 (6~20자의 영문 대소문자 및 숫자 조합)" />
              <span *ngIf="formErrors['password']" class="cred ml5">{{formErrors['password']}}</span>
            </td>
          </tr>
          <tr>
            <th><span class="necessary" >*</span>비밀번호 재입력</th>
            <td>
              <input type="password" id="passwordConfirm" formControlName="passwordConfirm" [ngClass]="{formErrors:formErrors['passwordConfirm']}" pattern="{{ this.form.get('password').value }}" />
              <span *ngIf="formErrors['passwordConfirm']" class="cred ml5">{{formErrors['passwordConfirm']}}</span>
            </td>
          </tr>
          <tr>
            <th><span class="necessary" >*</span>이름</th>
            <td>
              <input type="text" class="ro" id="userName" formControlName="userName" [ngClass]="{formErrors:formErrors['userName']}" readonly="true" />
              <span *ngIf="formErrors['userName']" class="cred ml5">{{formErrors['userName']}}</span>
            </td>
          </tr>
          <tr>
            <th>생년월일</th>
            <td>
              <input type="text" class="ro" id="birth" formControlName="birth" [ngClass]="{formErrors:formErrors['birth']}" />
              <span *ngIf="formErrors['birth']" class="cred ml5">{{formErrors['birth']}}</span>
            </td>
          </tr>
          <tr>
            <th>이름(영문명)</th>
            <td><input type="text" id="userEname" formControlName="userEname" /></td>
          </tr>
          <tr>
            <th>회사명</th>
            <td><input type="text" id="companyName" formControlName="companyName" /></td>
          </tr>
          <tr>
            <th>부서명</th>
            <td><input type="text" id="comDept" formControlName="comDept" /></td>
          </tr>
          <tr>
            <th><span class="necessary">*</span>이메일</th>
            <td>
              <input type="text" id="email" formControlName="email" [ngClass]="[formErrors['email'] ? 'formErrors' : '', formErrors['emailDupCheck'] ? 'formErrors' : '']" (keydown)="setEmailDupCheckInit()" />
              <button class="btn1" (click)="checkEmailDuplicate()">중복체크</button>
              <span *ngIf="formErrors['email']" class="cred">{{formErrors['email']}}</span>
              <span *ngIf="formErrors['emailDupCheck']" class="cred">이메일 중복체크을 하시기 바랍니다.</span>
              <input type="hidden" formControlName="emailDupCheck" pattern="{{checkTrue}}" />
            </td>
          </tr>
          <ng-container *ngIf="tabIndex!==0">
          <tr>
            <th>자택전화</th>
            <td class="tel">
              <input type="text" id="telephone1" formControlName="telephone1" [ngClass]="{formErrors:formErrors['telephone1']}" />
              <span class="between">-</span>
              <input type="text" id="telephone2" formControlName="telephone2" [ngClass]="{formErrors:formErrors['telephone2']}" />
              <span class="between">-</span>
              <input type="text" id="telephone3" formControlName="telephone3" [ngClass]="{formErrors:formErrors['telephone3']}" />
              <span *ngIf="formErrors['telephone1'] || formErrors['telephone2'] || formErrors['telephone3']" class="cred ml5">{{ formErrors['telephone1'] ? formErrors['telephone1'] : ( formErrors['telephone2'] ? formErrors['telephone2'] : ( formErrors['telephone3'] ? formErrors['telephone3'] : '' ) ) }}</span>
            </td>
          </tr>
          <tr>
            <th>핸드폰</th>
            <td class="tel">
              <input type="text" id="mobile1" formControlName="mobile1" [ngClass]="{formErrors:formErrors['mobile1']}" />
              <span class="between">-</span>
              <input type="text" id="mobile2" formControlName="mobile2" [ngClass]="{formErrors:formErrors['mobile2']}" />
              <span class="between">-</span>
              <input type="text" id="mobile3" formControlName="mobile3" [ngClass]="{formErrors:formErrors['mobile3']}" />
              <span *ngIf="formErrors['mobile1'] || formErrors['mobile2'] || formErrors['mobile3']" class="cred ml5">{{ formErrors['mobile1'] ? formErrors['mobile1'] : ( formErrors['mobile2'] ? formErrors['mobile2'] : ( formErrors['mobile3'] ? formErrors['mobile3'] : '' ) ) }}</span>
            </td>
          </tr>
          <tr>
            <th>주소</th>
            <td>
              <div class="zipcode">
                <input type="text" id="zipcode" formControlName="zipcode" readonly="true" />
                <btn-daum-address (result)="setDaumAddressApi($event)" [options]="daumAddressOptions"></btn-daum-address>
              </div>
              <input type="text" class="addr1" id="address" formControlName="address" readonly="true" />
              <input type="text" class="addr2" id="addressDetail" formControlName="addressDetail" placeholder="나머지 주소를 입력해 주세요."/>
            </td>
          </tr>
          </ng-container>
          <!--
          <tr>
            <th><span class="necessary">*</span>중복가입 방지</th>
            <td>
              <img src="/assets/images/captcha.bmp" alt="왼쪽의 글자를 순서대로 입력하세요." align="absbottom">
              <input type="text" class="capcha-input">왼쪽의 글자를 순서대로 입력하세요.
            </td>
          </tr>
          //-->
          <tr>
            <th>SMS수신</th>
            <td>
              <div class="radio">
                <label>예
                  <input type="radio" name="radio" id="smsCheckTrue" formControlName="smsCheck" name="smsCheck" [value]="true" />
                  <span class="checkmark"></span>
                </label>
                <label>아니오
                  <input type="radio" name="radio" id="smsCheckFalse" formControlName="smsCheck" name="smsCheck" [value]="false" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th>메일수신</th>
            <td>
              <div class="radio">
                <label>예
                  <input type="radio" name="radio" id="emailCheckTrue" formControlName="emailCheck" name="emailCheck" [value]="true" />
                  <span class="checkmark"></span>
                </label>
                <label>아니오
                  <input type="radio" name="radio" id="emailCheckFalse" formControlName="emailCheck" name="emailCheck" [value]="false" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </td>
          </tr>
          </tbody>
          </table>

          <div class="btn-area">
            <a class="btn1 join-btn cp" (click)="setMemberSave()">가입하기</a>
            <a routerLink="/" class="btn1 cancel-btn">취소</a>
          </div>
        </div>

      </form>
      </ng-container>
    </div>
    <div class="tab-pane" [ngClass]="{show: tabIndex==1, active: tabIndex==1, fadeIn: tabIndex==1, fade: tabIndex!==1}">
      <!--
      <app-member-kind3 *ngIf="tabIndex==1" [authInfo]="authInfo"></app-member-kind3>
      //-->
      <ng-container *ngIf="tabIndex==1">
      <form [formGroup]="form">

        <input type="hidden" id="userGubun" formControlName="userGubun" />
        <input type="hidden" id="birthType" formControlName="birthType" />
        <input type="hidden" id="memberStatus" formControlName="memberStatus" />
        <input type="hidden" id="gender" formControlName="gender" />
        <input type="hidden" id="dupinfo" formControlName="dupinfo" />

        <div class="join-input">
          <div class="page-title">일반회원 정보입력</div>

          <div class="info">*필수입력입니다.</div>

          <table>
          <colgroup>
            <col class="col1">
            <col class="col2">
          </colgroup>

          <tbody>
          <tr>
            <th><span class="necessary">*</span>아이디</th>
            <td>
              <input type="text" id="userId" formControlName="userId" [ngClass]="[formErrors['userId'] ? 'formErrors' : '', formErrors['idCheck'] ? 'formErrors' : '']" placeholder="{{ formErrors['userId'] ? formErrors['userId'] : '아이디 (띄어쓰기 없이 5~20자의 영문,숫자)' }}" (keydown)="setIdCheckInit()" />
              <button class="btn1" (click)="checkIdDuplicate()">중복체크</button>
              <span *ngIf="!formErrors['idCheck']" class="">(아이디 중복체크를 하셔야만 등록 가능합니다.)</span>
              <span *ngIf="formErrors['idCheck']" class="cred">아이디 중복체크을 하시기 바랍니다.</span>
              <input type="hidden" formControlName="idCheck" pattern="{{checkTrue}}" />
            </td>
          </tr>
          <tr>
            <th><span class="necessary">*</span>비밀번호</th>
            <td>
              <input type="password" id="password" formControlName="password" [ngClass]="{formErrors:formErrors['password']}" placeholder="비밀번호 (6~20자의 영문 대소문자 및 숫자 조합)" />
              <span *ngIf="formErrors['password']" class="cred ml5">{{formErrors['password']}}</span>
            </td>
          </tr>
          <tr>
            <th><span class="necessary" >*</span>비밀번호 재입력</th>
            <td>
              <input type="password" id="passwordConfirm" formControlName="passwordConfirm" [ngClass]="{formErrors:formErrors['passwordConfirm']}" pattern="{{ this.form.get('password').value }}" />
              <span *ngIf="formErrors['passwordConfirm']" class="cred ml5">{{formErrors['passwordConfirm']}}</span>
            </td>
          </tr>
          <tr>
            <th><span class="necessary" >*</span>이름</th>
            <td>
              <input type="text" class="ro" id="userName" formControlName="userName" [ngClass]="{formErrors:formErrors['userName']}" readonly="true" />
              <span *ngIf="formErrors['userName']" class="cred ml5">{{formErrors['userName']}}</span>
            </td>
          </tr>
          <tr>
            <th>생년월일</th>
            <td>
              <input type="text" class="ro" id="birth" formControlName="birth" [ngClass]="{formErrors:formErrors['birth']}" />
              <span *ngIf="formErrors['birth']" class="cred ml5">{{formErrors['birth']}}</span>
            </td>
          </tr>
          <tr>
            <th>이름(영문명)</th>
            <td><input type="text" id="userEname" formControlName="userEname" /></td>
          </tr>
          <tr>
            <th>회사명</th>
            <td><input type="text" id="companyName" formControlName="companyName" /></td>
          </tr>
          <tr>
            <th>부서명</th>
            <td><input type="text" id="comDept" formControlName="comDept" /></td>
          </tr>
          <tr>
            <th><span class="necessary">*</span>이메일</th>
            <td>
              <input type="text" id="email" formControlName="email" [ngClass]="[formErrors['email'] ? 'formErrors' : '', formErrors['emailDupCheck'] ? 'formErrors' : '']" (keydown)="setEmailDupCheckInit()" />
              <button class="btn1" (click)="checkEmailDuplicate()">중복체크</button>
              <span *ngIf="formErrors['email']" class="cred">{{formErrors['email']}}</span>
              <span *ngIf="formErrors['emailDupCheck']" class="cred">이메일 중복체크을 하시기 바랍니다.</span>
              <input type="hidden" formControlName="emailDupCheck" pattern="{{checkTrue}}" />
            </td>
          </tr>
          <tr>
            <th><span class="necessary">*</span>자택전화</th>
            <td class="tel">
              <input type="text" id="telephone1" formControlName="telephone1" [ngClass]="{formErrors:formErrors['telephone1']}" />
              <span class="between">-</span>
              <input type="text" id="telephone2" formControlName="telephone2" [ngClass]="{formErrors:formErrors['telephone2']}" />
              <span class="between">-</span>
              <input type="text" id="telephone3" formControlName="telephone3" [ngClass]="{formErrors:formErrors['telephone3']}" />
              <span *ngIf="formErrors['telephone1'] || formErrors['telephone2'] || formErrors['telephone3']" class="cred ml5">{{ formErrors['telephone1'] ? formErrors['telephone1'] : ( formErrors['telephone2'] ? formErrors['telephone2'] : ( formErrors['telephone3'] ? formErrors['telephone3'] : '' ) ) }}</span>
            </td>
          </tr>
          <tr>
            <th><span class="necessary">*</span>핸드폰</th>
            <td class="tel">
              <input type="text" id="mobile1" formControlName="mobile1" [ngClass]="{formErrors:formErrors['mobile1']}" />
              <span class="between">-</span>
              <input type="text" id="mobile2" formControlName="mobile2" [ngClass]="{formErrors:formErrors['mobile2']}" />
              <span class="between">-</span>
              <input type="text" id="mobile3" formControlName="mobile3" [ngClass]="{formErrors:formErrors['mobile3']}" />
              <span *ngIf="formErrors['mobile1'] || formErrors['mobile2'] || formErrors['mobile3']" class="cred ml5">{{ formErrors['mobile1'] ? formErrors['mobile1'] : ( formErrors['mobile2'] ? formErrors['mobile2'] : ( formErrors['mobile3'] ? formErrors['mobile3'] : '' ) ) }}</span>
            </td>
          </tr>
          <tr>
            <th>주소</th>
            <td>
              <div class="zipcode">
                <input type="text" id="zipcode" formControlName="zipcode" readonly="true" />
                <btn-daum-address (result)="setDaumAddressApi($event)" [options]="daumAddressOptions"></btn-daum-address>
                <!--
                <button class="zip-btn">우편번호찾기</button>
                //-->
              </div>
              <input type="text" class="addr1" id="address" formControlName="address" readonly="true" />
              <input type="text" class="addr2" id="addressDetail" formControlName="addressDetail" placeholder="나머지 주소를 입력해 주세요."/>
            </td>
          </tr>
          <!--
          <tr>
            <th><span class="necessary">*</span>중복가입 방지</th>
            <td>
              <img src="/assets/images/captcha.bmp" alt="왼쪽의 글자를 순서대로 입력하세요." align="absbottom">
              <input type="text" class="capcha-input">왼쪽의 글자를 순서대로 입력하세요.
            </td>
          </tr>
          //-->
          <tr>
            <th>SMS수신</th>
            <td>
              <div class="radio">
                <label>예
                  <input type="radio" name="radio" id="smsCheckTrue" formControlName="smsCheck" name="smsCheck" [value]="true" />
                  <span class="checkmark"></span>
                </label>
                <label>아니오
                  <input type="radio" name="radio" id="smsCheckFalse" formControlName="smsCheck" name="smsCheck" [value]="false" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th>메일수신</th>
            <td>
              <div class="radio">
                <label>예
                  <input type="radio" name="radio" id="emailCheckTrue" formControlName="emailCheck" name="emailCheck" [value]="true" />
                  <span class="checkmark"></span>
                </label>
                <label>아니오
                  <input type="radio" name="radio" id="emailCheckFalse" formControlName="emailCheck" name="emailCheck" [value]="false" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </td>
          </tr>
          </tbody>
          </table>

          <div class="btn-area">
            <a class="btn1 join-btn cp" (click)="setMemberSave()">가입하기</a>
            <a routerLink="/" class="btn1 cancel-btn">취소</a>
          </div>
        </div>

      </form>
      </ng-container>
    </div>
    <div class="tab-pane" [ngClass]="{show: tabIndex==2, active: tabIndex==2, fadeIn: tabIndex==2, fade: tabIndex!==2}">
      <!--
      <app-member-kind2 *ngIf="tabIndex==2" [authInfo]="authInfo"></app-member-kind2>
      //-->
      <ng-container *ngIf="tabIndex==2">
      <form [formGroup]="form">

        <input type="hidden" id="userGubun" formControlName="userGubun" />
        <input type="hidden" id="memberStatus" formControlName="memberStatus" />
        <input type="hidden" id="birth" formControlName="birth" />
        <input type="hidden" id="birthType" formControlName="birthType" />
        <input type="hidden" id="gender" formControlName="gender" />
        <input type="hidden" id="dupinfo" formControlName="dupinfo" />
        <input type="hidden" id="emailDupCheck" formControlName="emailDupCheck" />
        <input type="hidden" id="telephone1" formControlName="telephone1" />
        <input type="hidden" id="telephone2" formControlName="telephone2" />
        <input type="hidden" id="telephone3" formControlName="telephone3" />

        <div class="join-input">
          <div class="page-title">기업정보</div>

          <div class="info">*필수입력입니다.</div>

          <table class="mb50">
          <colgroup>
            <col class="col1">
            <col class="col2">
          </colgroup>

          <tbody>
          <tr>
            <th><span class="necessary">*</span>기업명</th>
            <td>
              <input type="hidden" id="companySeq" formControlName="companySeq" />
              <input type="text" class="ro" id="companyName" formControlName="companyName" [ngClass]="{formErrors:formErrors['companyName']}" readonly="true" />
              <button class="btn1 btn2" (click)="setCompanySelected()">찾아보기</button>
            </td>
          </tr>
          <tr>
            <th><span class="necessary">*</span>사업자번호</th>
            <td>
              <input type="text" id="comNumber" formControlName="comNumber"  [ngClass]="[formErrors['comNumber'] ? 'formErrors' : '', formErrors['companyCheck'] ? 'formErrors' : '']" placeholder="사업자번호 입력 예시 : 123-12-12345" (keydown)="setCompanyCheckInit()" />
              <span *ngIf="formErrors['comNumber']" class="cred">{{formErrors['comNumber']}}</span>
              <button class="btn1 btn2" (click)="checkCompanyNumber()">정보확인</button>
              <span *ngIf="formErrors['companyCheck']" class="cred">정보확인을 하시기 바랍니다.</span>
              <input type="hidden" formControlName="companyCheck" pattern="{{checkTrue}}" />
            </td>
          </tr>
          </tbody>
          </table>

          <div class="page-title">기업아이디 정보</div>

          <div class="info">*필수입력입니다.</div>

          <table>
          <colgroup>
            <col class="col1">
            <col class="col2">
          </colgroup>

          <tbody>
          <tr>
            <th><span class="necessary">*</span>아이디</th>
            <td>
              <input type="text" id="userId" formControlName="userId" [ngClass]="[formErrors['userId'] ? 'formErrors' : '', formErrors['idCheck'] ? 'formErrors' : '']" placeholder="{{ formErrors['userId'] ? formErrors['userId'] : '아이디 (띄어쓰기 없이 5~20자의 영문,숫자)' }}" (keydown)="setIdCheckInit()" />
              <button class="btn1" (click)="checkIdDuplicate()">중복체크</button>
              <span *ngIf="!formErrors['idCheck']" class="">(아이디 중복체크를 하셔야만 등록 가능합니다.)</span>
              <span *ngIf="formErrors['idCheck']" class="cred">아이디 중복체크을 하시기 바랍니다.</span>
              <input type="hidden" formControlName="idCheck" pattern="{{checkTrue}}" />
            </td>
          </tr>
          <tr>
            <th><span class="necessary">*</span>비밀번호</th>
            <td>
              <input type="password" id="password" formControlName="password" [ngClass]="{formErrors:formErrors['password']}" placeholder="비밀번호 (6~20자의 영문 대소문자 및 숫자 조합)" />
              <span *ngIf="formErrors['password']" class="cred ml5">{{formErrors['password']}}</span>
            </td>
          </tr>
          <tr>
            <th><span class="necessary" >*</span>비밀번호 재입력</th>
            <td>
              <input type="password" id="passwordConfirm" formControlName="passwordConfirm" [ngClass]="{formErrors:formErrors['passwordConfirm']}" pattern="{{ this.form.get('password').value }}" />
              <span *ngIf="formErrors['passwordConfirm']" class="cred ml5">{{formErrors['passwordConfirm']}}</span>
            </td>
          </tr>
          <tr>
            <th><span class="necessary" >*</span>이름</th>
            <td>
              <input type="text" class="ro" id="userName" formControlName="userName" [ngClass]="{formErrors:formErrors['userName']}" readonly="true" />
              <span *ngIf="formErrors['userName']" class="cred ml5">{{formErrors['userName']}}</span>
            </td>
          </tr>
          <tr>
            <th>부서명</th>
            <td><input type="text" id="comDept" formControlName="comDept" /></td>
          </tr>
          <tr>
            <th>담당업무</th>
            <td><input type="text" id="comJob" formControlName="comJob" /></td>
          </tr>
          <tr>
            <th><span class="necessary">*</span>연락처</th>
            <td class="tel">
              <input type="text" id="mobile1" formControlName="mobile1" [ngClass]="{formErrors:formErrors['mobile1']}" />
              <span class="between">-</span>
              <input type="text" id="mobile2" formControlName="mobile2" [ngClass]="{formErrors:formErrors['mobile2']}" />
              <span class="between">-</span>
              <input type="text" id="mobile3" formControlName="mobile3" [ngClass]="{formErrors:formErrors['mobile3']}" />
              <span *ngIf="formErrors['mobile1'] || formErrors['mobile2'] || formErrors['mobile3']" class="cred ml5">{{ formErrors['mobile1'] ? formErrors['mobile1'] : ( formErrors['mobile2'] ? formErrors['mobile2'] : ( formErrors['mobile3'] ? formErrors['mobile3'] : '' ) ) }}</span>
            </td>
          </tr>
          <tr>
            <th>이메일</th>
            <td>
              <input type="text" id="email" formControlName="email" />
            </td>
          </tr>
          </tbody>
          </table>

          <div class="btn-area">
            <a class="btn1 join-btn cp" (click)="setMemberSave()">가입하기</a>
            <a routerLink="/" class="btn1 cancel-btn">취소</a>
          </div>
        </div>

      </form>
      </ng-container>
    </div>
  </div>
</div>

</ng-container>

</div>

<app-footer></app-footer>
